import React from 'react';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import AuditCardItems from './AuditCardItems';

const AuditCards = ({
  category,
  code,
  handleScroll,
  items,
  itemsPerRow,
  readErrors,
  readStatus,
}) => (
  <InfiniteScrollCards
    handleScroll={handleScroll}
    className="aridhia-audit-cards"
    icon="history"
    itemsPerRow={itemsPerRow}
    entity="audit"
    readStatus={[readStatus]}
    readErrors={readErrors}
    items={items}
    loading
  >
    <AuditCardItems category={category} code={code} items={items} />
  </InfiniteScrollCards>
);

export default AuditCards;
